export default __webpack_public_path__ + "static/media/cafedelmar.1fd07511.jpg";